import PropTypes from 'prop-types';
import React from 'react';

const MexicoSpecificFooter = ({ referenceNumber }) => (
  <>
    <p>REFERENCIA: {referenceNumber}</p>
    <br />
  </>
);

MexicoSpecificFooter.defaultProps = {
  referenceNumber: ''
};

MexicoSpecificFooter.propTypes = {
  referenceNumber: PropTypes.string,
};

export default MexicoSpecificFooter;
